<template>
    <v-card variant="flat">
        <v-tabs v-model="tab" bg-color="secondary">
            <v-tab value="resultados" prepend-icon="mdi-file-question-outline"><span class="d-none d-sm-inline">{{
                t('Resultados') }}</span></v-tab>
            <v-tab value="cuestionarios" prepend-icon="mdi-file-question-outline"><span class="d-none d-sm-inline">{{
                t('Cuestionarios') }}</span></v-tab>
            <v-tab value="variables" prepend-icon="mdi-variable">
                <span class="d-none d-sm-inline">{{ t('Variables') }}</span></v-tab>
        </v-tabs>
        <v-window disabled v-model="tab">
            <v-window-item value="resultados">
                <v-toolbar flat>
                    <v-toolbar-title>{{ t('Resultados') }}</v-toolbar-title>
                    <ExportExcel :dataItems="resultados" />
                </v-toolbar>
                <v-text-field class="ma-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
                    variant="outlined" hide-details></v-text-field>
                <v-data-table-virtual :headers="headersr" :items="resultados" :search="search" :loading="loading">
                    <template v-slot:loading>
                        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                    </template>
                </v-data-table-virtual>
            </v-window-item>
            <v-window-item value="cuestionarios">
                <v-toolbar flat>
                    <v-toolbar-title>{{ t('Cuestionarios') }}</v-toolbar-title>
                    <v-btn fab small color="primary" @click="newEncuesta" class="ma-2">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <ExportExcel :dataItems="encuestas" />
                </v-toolbar>
                <v-text-field class="ma-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
                    variant="outlined" hide-details></v-text-field>
                <v-data-table-virtual :headers="headers" :items="encuestas" :search="search" :loading="loading">
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon small @click="editEncuesta(item)">mdi-pencil</v-icon>
                    </template>
                    <template v-slot:loading>
                        <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                    </template>
                </v-data-table-virtual>
            </v-window-item>
            <v-window-item value="variables">
                <AdminVariables></AdminVariables>
            </v-window-item>
        </v-window>
    </v-card>
    <v-dialog v-model="editDialog" persistent>
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ editedEncuesta.id ? t('Editar') : t('Crear') }} {{ t('encuesta')
                }}</v-toolbar-title>
                <v-btn @click="save" prepend-icon="mdi-content-save">
                    {{ t('Guardar') }}
                </v-btn>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-text-field v-model="editedEncuesta.titulo" :label="t('Nombre')"></v-text-field>
                <v-text-field v-model="editedEncuesta.descripcion" :label="t('Descripción')"></v-text-field>
                <v-row v-if="editedEncuesta.id">
                    <v-data-table :headers="headersve" :items="editedEncuesta.encuesta_variables"
                        @click:row="editVariable" hide-default-footer>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>{{ t('Variables') }}</v-toolbar-title>
                                <v-btn color="primary" @click="newVariable">
                                    <v-icon>mdi-plus</v-icon>
                                    {{ t('Anadir') }} {{ t('variables') }}
                                </v-btn>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item.requerido`]="{ item }">
                            <v-checkbox v-model="item.requerido" readonly></v-checkbox>
                        </template>
                    </v-data-table>
                    <v-col cols="12" class="pa-5">
                        <v-btn block class="ma-3" color="red darken-1" text @click="openDeleteConfirmDialog()">
                            {{ t('Eliminar') }} {{ t('encuesta') }}</v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="!editedEncuesta.id">
                    Para añadir variables a la encuesta, guardala primero.
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="showDeleteConfirmDialog" persistent max-width="500px">
        <v-card>
            <v-card-title>{{ t('Estás_seguro') }}</v-card-title>
            <v-card-text>
                {{ t('Estás_seguro_que_quieres_eliminar') }} {{ t('la_encuesta') }} "{{ editedEncuesta.titulo }}"? {{
                    t('Esta_acción_es_irreversible') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="showDeleteConfirmDialog = false">{{ t('Cancelar') }}</v-btn>
                <v-btn color="red darken-1" text @click="confirmDeleteEncuesta">{{ t('Eliminar') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="addVariableDialog">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Añade_una_variable_a_la_encuesta') }}</v-toolbar-title>
                <v-btn color="primary" @click="saveVariable" prepend-icon="mdi-content-save">
                    {{ t('Guardar') }}
                </v-btn>
                <v-btn icon @click="addVariableDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-text-field v-model="editedVariable.variable" disabled :label="t('Variable')"></v-text-field>
                <v-text-field v-model="editedVariable.etiqueta_real" :label="t('Etiqueta_real')"></v-text-field>
                <v-text-field v-model="editedVariable.orden" :label="t('Orden')"></v-text-field>
                <v-text-field v-model="editedVariable.etiqueta_personalizada"
                    :label="t('Etiqueta_personalizada')"></v-text-field>
                <v-text-field class="mx-4 mt-4" v-model="search" :placeholder="t('Cerca')"
                    prepend-inner-icon="mdi-magnify" single-line variant="outlined" hide-details />
                <v-data-table-virtual :headers="headersv" :items="variables" :search="searchvar" :loading="loadingvar">
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon small class="mr-2" @click="addVariable(item)">mdi-plus</v-icon>
                    </template>
                    <template v-slot:loading>
                        <v-skeleton-loader type="table-row@10" />
                    </template>
                </v-data-table-virtual>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios';

// 1. Imports de Pinia
import { useUiStore } from '@/stores/ui';
import { useEncuestasStore } from '@/stores/encuestas';

import ExportExcel from './ExportExcel.vue';
import AdminVariables from './AdminVariables.vue';

const uiStore = useUiStore();
const encuestasStore = useEncuestasStore();

const { t } = useI18n();

const search = ref('');
const searchvar = ref('');

const encuestas = computed(() => encuestasStore.encuestas);
const loading = computed(() => encuestasStore.loadingEncuestas);

const variables = ref([]);
const resultados = ref([]);
const tab = ref(null);

const headers = ref([
    { title: t('Nombre'), key: 'titulo' },
    { title: t('Descripción'), key: 'descripcion' },
    { title: t('Número_de_variables'), key: 'num_vars' },
    { title: t('Acciones'), key: 'action', sortable: false },
]);
const headersve = ref([
    { title: t('Variable'), key: 'variable' },
    { title: t('Etiqueta'), key: 'etiqueta' },
    { title: t('Tipo'), key: 'tipo' },
    { title: t('Requerido'), key: 'requerido' },
    { title: t('Orden'), key: 'orden' },
])
const headersv = ref([
    { title: t('Variable'), key: 'nombre' },
    { title: t('Etiqueta'), key: 'etiqueta' },
    { title: t('Tipo'), key: 'tipo' },
    { title: t('Acciones'), key: 'action', sortable: false },
])

const headersr = ref([
])

const snackbarText = ref('');
const editDialog = ref(false);
const addVariableDialog = ref(false);
const editedEncuesta = ref({});
const editedVariable = ref({})

const loadingvar = ref(false);
const loading2 = ref(false);
const showDeleteConfirmDialog = ref(false);

function fetchEncuestas() {
    loading.value = true;
    axios.get('encuestas/')
        .then(response => {
            encuestas.value = response.data;
        })
        .catch(error => {
            console.error('Error fetching encuestas:', error);
        })
        .finally(() => {
            loading.value = false;
        });
}

function editEncuesta(encuesta) {
    editedEncuesta.value = { ...encuesta };
    editDialog.value = true;
}

function newEncuesta() {
    Object.assign(editedEncuesta.value, { id: null, titulo: '', descripcion: '' });
    editDialog.value = true;
}

function newVariable() {
    editedVariable.value = {
        id: null,
        encuesta: editedEncuesta.value.id,
        variable: null,
        etiqueta: '',
        requerido: false,
        orden: 0,
    }
    addVariableDialog.value = true
}

function editVariable(e, { item }) {
    editedVariable.value = {
        ...item,
        encuesta: editedEncuesta.value.id
    }
    addVariableDialog.value = true
}

function addVariable(variable) {
    editedVariable.value.variable = variable.id
    editedVariable.value.etiqueta_real = variable.etiqueta
}

function save() {
    const method = editedEncuesta.value.id ? 'put' : 'post';
    const url = editedEncuesta.value.id ? `encuestas/${editedEncuesta.value.id}/` : 'encuestas/';
    axios[method](url, editedEncuesta.value)
        .then(() => {
            fetchEncuestas();
            editDialog.value = false;
            snackbarText.value = editedEncuesta.value.titulo + ' ' + 'fue actualizado con éxito';
            uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
        })
        .catch(error => {
            uiStore.triggerSnackbar({ message: error, color: 'error' });
            console.error('Error saving the encuesta:', error);
        });
}

function saveVariable() {
    const method = editedVariable.value.id ? 'put' : 'post';
    const url = editedVariable.value.id ? `encuestavariables/${editedVariable.value.id}/` : 'encuestavariables/';
    axios[method](url, editedVariable.value)
        .then(() => {
            fetchEncuestas();
            editDialog.value = false;
            snackbarText.value = editedVariable.value.titulo + ' ' + 'fue actualizado con éxito';
            uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
        })
        .catch(error => {
            uiStore.triggerSnackbar({ message: error, color: 'error' });
            console.error('Error saving the encuesta:', error);
        });
}

const openDeleteConfirmDialog = () => {
    showDeleteConfirmDialog.value = true;
};

const confirmDeleteEncuesta = () => {
    loading2.value = true;
    axios.delete(`encuestas/${editedEncuesta.value.id}`)
        .then(() => {
            editDialog.value = false;
            showDeleteConfirmDialog.value = false;
            snackbarText.value = t("se_ha_eliminado_con_éxito");
            uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' });
            fetchEncuestas();
            loading2.value = false;
        })
        .catch(error => uiStore.triggerSnackbar({ message: error, color: 'error' }))
        .finally(() => (loading2.value = false));
};

function close() {
    editDialog.value = false;
}

function fetchVariables() {
    loadingvar.value = true;
    axios.get('variables/')
        .then(({ data }) => {
            variables.value = data;
        })
        .catch(err => console.error('Error fetching variables:', err))
        .finally(() => { loadingvar.value = false; });
}

onMounted(async () => {
  loading.value = true;
  encuestasStore.fetchEncuestas();
    fetchVariables();
  try {
    const { data } = await axios.get('resultados_escala_por_curso/');
    headersr.value    = data.headers;
    resultados.value  = data.rows;
  } catch (err) {
    console.error('Error al obtener resultados:', err);
  } finally {
    loading.value = false;
  }
});
</script>
